module.exports = __webpack_public_path__ + "static/media/file-text.6ebff2d3.svg";